module.exports = __webpack_public_path__ + "static/media/grid.ccab81f0.svg";